import Vue from 'vue';
import Router from 'vue-router';

// Containers
const TheContainer = () => import('@/containers/TheContainer');

// Views
const Dashboard = () => import('@/views/Dashboard');
const DaftarKehadiran = () => import('@/views/DaftarKehadiran');
const KedisiplinanPegawai = () => import('@/views/KedisiplinanPegawai');
const IzinCuti = () => import('@/views/IzinCuti');
const AbsensiLuarRadius = () => import('@/views/AbsensiLuarRadius');
const AbsenBulanRamadhan = () => import('@/views/AbsenBulanRamadhan');
const KoreksiAbsensi = () => import('@/views/KoreksiAbsen');
const Seragam = () => import('@/views/Seragam');
const MapsTracking = () => import('@/views/MapsTracking');
const Report = () => import('@/views/Report');
const ReportVDP = () => import('@/views/ReportVDP');
const Device = () => import('@/views/master/device/DaftarDevice');
const Pengumuman = () => import('@/views/master/pesan/Pesan');
const Billing = () => import('@/views/Billing');

// Views Master
// Views Master Perusahaan
const DaftarKeluarga = () => import('@/views/master/keluarga/DaftarKeluarga');
const TambahKeluarga = () => import('@/views/master/keluarga/TambahKeluarga');

// Views Master Perusahaan
const DaftarPerusahaan = () =>
  import('@/views/master/perusahaan/DaftarPerusahaan');
const TambahPerusahaan = () =>
  import('@/views/master/perusahaan/TambahPerusahaan');
const ApprovalPerusahaan = () =>
  import('@/views/master/perusahaan/ApprovalPerusahaan');
const SegmenPerusahaan = () =>
  import('@/views/master/perusahaan/SegmenPerusahaan');

// Views Master Pegawai
const DaftarPegawai = () => import('@/views/master/pegawai/DaftarPegawai');
const TambahPegawai = () => import('@/views/master/pegawai/TambahPegawai');
const PushNotif = () => import('@/views/master/pegawai/PushNotif');

// Views Master Kantor
const DaftarKantor = () => import('@/views/master/kantor/DaftarKantor');
const TambahKantor = () => import('@/views/master/kantor/TambahKantor');

// Views Master EmployeeWorkplace
const DaftarEmployeeWorkplace = () =>
  import('@/views/master/employeeWorkplace/DaftarEmployeeWorkplace');
const TambahEmployeeWorkplace = () =>
  import('@/views/master/employeeWorkplace/TambahEmployeeWorkplace');

// Views Master Atasan Pegawai
const DaftarAtasanPegawai = () =>
  import('@/views/master/atasan/DaftarAtasanPegawai');
const TambahAtasanPegawai = () =>
  import('@/views/master/atasan/TambahAtasanPegawai');

// Views Master Unit
const DaftarUnit = () => import('@/views/master/unit/DaftarUnit');
const TambahUnit = () => import('@/views/master/unit/TambahUnit');

// Views Master Jam Kerja
const DaftarJamKerja = () => import('@/views/master/jamKerja/DaftarJamKerja');
const TambahJamKerja = () => import('@/views/master/jamKerja/TambahJamKerja');

// Views Master Kalendar
const DaftarKalendar = () => import('@/views/master/kalendar/DaftarKalendar');
const TambahKalendar = () => import('@/views/master/kalendar/TambahKalendar');

// Views Master Shift
const DaftarShift = () => import('@/views/master/shift/DaftarShift');
const TambahShift = () => import('@/views/master/shift/TambahShift');

// Views Master Role
const DaftarRole = () => import('@/views/master/role/DaftarRole');
const TambahRole = () => import('@/views/master/role/TambahRole');

// Views Master Menu
const DaftarMenu = () => import('@/views/master/menu/DaftarMenu');
const TambahMenu = () => import('@/views/master/menu/TambahMenu');

// Views Master Menu Mobile
const TambahMenuMobile = () =>
  import('@/views/master/menuMobile/TambahMenuMobile');
const TambahMenuPegawaiMobile = () =>
  import('@/views/master/menuMobile/TambahMenuPegawaiMobile');

// Views Master Role Menu
const DaftarRoleMenu = () => import('@/views/master/roleMenu/DaftarRoleMenu');
const TambahRoleMenu = () => import('@/views/master/roleMenu/TambahRoleMenu');

// Views Master Tipe Absen
const DaftarKategoriTidakMasuk = () =>
  import('@/views/master/presensi/DaftarPresensi');
const TambahKategoriTidakMasuk = () =>
  import('@/views/master/presensi/TambahPresensi');

// Views Master Tipe Pegawai
const DaftarTipePegawai = () =>
  import('@/views/master/tipePegawai/DaftarTipePegawai');
const TambahTipePegawai = () =>
  import('@/views/master/tipePegawai/TambahTipePegawai');

// Views Master Admin
const DaftarAdmin = () => import('@/views/master/admin/Admin');

// Views Master Magang
const DaftarMagang = () => import('@/views/master/magang/DaftarRekapitulasi');
const TambahMagang = () => import('@/views/master/magang/TambahRekapitulasi');
const SelesaiMagang = () => import('@/views/master/magang/SelesaiMagang');
const ReportMagang = () => import('@/views/master/magang/Report');

// Views Master Reimburs
const DaftarReimburse = () =>
  import('@/views/master/reimburse/DaftarReimburse');
const PaymentReimburse = () =>
  import('@/views/master/reimburse/PaymentReimburse');
const ApprovalReimburse = () =>
  import('@/views/master/reimburse/ApprovalReimburse');

// Views Master E-Overtime
const RekapitulasiEOvertime = () =>
  import('@/views/master/eovertime/RekapitulasiEOvertime');
const DetailEOvertime = () =>
  import('@/views/master/eovertime/DetailEOvertime');

// Views Master Version
const MonitoringVersion = () =>
  import('@/views/master/version/MonitoringVersion');

// Views Master Status
const StatusApproval = () => import('@/views/master/status/Approval');

// Views Master Vaksin
const DaftarVaksin = () => import('@/views/master/vaksin/DaftarVaksin');

// Views Master Bauk PO
const DaftarBaukPo = () => import('@/views/master/baukPo/DaftarBaukPo');

// Views Master Bauk Non PO
const DaftarBaukNonPo = () =>
  import('@/views/master/baukNonPo/DaftarBaukNonPo');

// Views Master Kontrak
const DaftarKontrakPerusahaan = () =>
  import('@/views/master/kontrak/DaftarKontrakPerusahaan');
const DaftarKontrakPegawai = () =>
  import('@/views/master/kontrak/DaftarKontrakPegawai');
const DaftarPengadaan = () => import('@/views/master/kontrak/DaftarPengadaan');

// Views Master Gaji
const AttrPayroll = () => import('@/views/master/gaji/AtributGaji');
const SlipPayroll = () => import('@/views/master/gaji/Gaji');
const MasterPayroll = () => import('@/views/master/gaji/MasterGaji');

// Views IBC Internal
const DispositionIBCInternal = () =>
  import('@/views/master/IBC/Internal/Disposition');
const InboxIBCInternal = () => import('@/views/master/IBC/Internal/Inbox');
const DraftIBCInternal = () => import('@/views/master/IBC/Internal/Draft');
const SentIBCInternal = () => import('@/views/master/IBC/Internal/Sent');
const CreateIBCInternal = () => import('@/views/master/IBC/Internal/Create');
const ApprovalIBCInternal = () =>
  import('@/views/master/IBC/Internal/Approval');
const RequestIBCInternal = () => import('@/views/master/IBC/Internal/Request');

// Views IBC Eksternal
const DispositionIBCEksternal = () =>
  import('@/views/master/IBC/Eksternal/Disposition');
const InboxIBCEksternal = () => import('@/views/master/IBC/Eksternal/Inbox');
const DraftIBCEksternal = () => import('@/views/master/IBC/Eksternal/Draft');
const SentIBCEksternal = () => import('@/views/master/IBC/Eksternal/Sent');
const CreateIBCEksternal = () => import('@/views/master/IBC/Eksternal/Create');
const ApprovalIBCEksternal = () =>
  import('@/views/master/IBC/Eksternal/Approval');
const RequestIBCEksternal = () =>
  import('@/views/master/IBC/Eksternal/Request');
const UploadIBCEksternal = () => import('@/views/master/IBC/Eksternal/Upload');

// Views IBC Master
const TempatIBC = () => import('@/views/master/IBC/Master/Tempat');
const JenisIBC = () => import('@/views/master/IBC/Master/Jenis');
const ActionIBC = () => import('@/views/master/IBC/Master/Action');
const MasalahIBC = () => import('@/views/master/IBC/Master/Masalah');
const SuratAdmin = () => import('@/views/master/IBC/SuratAdmin');
const RekapSurat = () => import('@/views/master/IBC/RekapSurat');
const MigrasiSurat = () => import('@/views/master/IBC/MigrasiSurat');

// Views IBC Lihat Surat
const LihatIBC = () => import('@/views/master/IBC/Lihat');
const LihatExcel = () => import('@/views/master/IBC/LihatExcel');

// Views Master Super Administrator
const DashboardAdmin = () => import('@/views/master/superAdmin/Dashboard');
const BillingAdmin = () => import('@/views/master/superAdmin/Billing');
const ApprovalBilling = () =>
  import('@/views/master/superAdmin/ApprovalBilling');

// Views Covid Testing
const DaftarTes = () => import('@/views/master/covidTesting/DaftarTes');
const InputTes = () => import('@/views/master/covidTesting/InputTes');
const DaftarTesMandiri = () =>
  import('@/views/master/covidTesting/DaftarTesMandiri');
const JadwalTes = () => import('@/views/master/covidTesting/JadwalTes');

// Views Covid Tracing
const HasilTes = () => import('@/views/master/covidTesting/HasilTes');
const ApprovalTes = () => import('@/views/master/covidTesting/ApprovalTes');

// Views - Pages
const Page404 = () => import('@/views/pages/Page404');
const PageNotFound = () => import('@/views/pages/Page404');
const Page500 = () => import('@/views/pages/Page500');
const Login = () => import('@/views/pages/Login');
const PrivacyPolicy = () => import('@/views/pages/PrivacyPolicy');
const Register = () => import('@/views/pages/Register');
const OpenMobileApp = () => import('@/views/pages/OpenMobileApp');
const LogoutSession = () => import('@/views/pages/LogoutSession');

Vue.use(Router);

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  base: process.env.BASE_URL,
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

function configRoutes() {
  return [
    {
      path: '/openapp',
      name: 'OpenApp',
      component: OpenMobileApp,
    },
    {
      path: '/',
      redirect: '/pages/login',
      component: TheContainer,
      children: [
        {
          path: 'session-end',
          name: 'LogoutSession',
          component: LogoutSession,
          beforeEnter(to, from, next) {
            const loginType = localStorage.getItem('loginType');
            if (loginType === 'SSO') {
              localStorage.clear();
              sessionStorage.clear();
              next('/pages/login');
            } else {
              next('/dashboard');
            }
          },
        },
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          beforeEnter(to, from, next) {
            if (localStorage.getItem('token')) {
              let menu = localStorage.getItem('menus').split(',');
              let i = 0;
              let status = false;
              for (i = 0; i < menu.length; i++) {
                if (menu[i] == 'Dashboard') {
                  status = true;
                  break;
                } else {
                  status = false;
                }
              }
              if (status == true) {
                next();
              } else {
                next('/pages/404');
              }
            } else {
              next('/pages/login');
            }
          },
        },
        {
          path: 'attendance',
          name: 'Attendance',
          component: DaftarKehadiran,
          beforeEnter(to, from, next) {
            if (localStorage.getItem('token')) {
              let menu = localStorage.getItem('menus').split(',');
              let i = 0;
              let status = false;
              for (i = 0; i < menu.length; i++) {
                if (menu[i] == 'Absensi Kehadiran') {
                  status = true;
                  break;
                } else {
                  status = false;
                }
              }
              if (status == true) {
                next();
              } else {
                next('/pages/404');
              }
            } else {
              next('/pages/login');
            }
          },
        },
        {
          path: 'absensi-luar-radius',
          name: 'AbsensiLuarRadius',
          component: AbsensiLuarRadius,
          beforeEnter(to, from, next) {
            if (localStorage.getItem('token')) {
              let menu = localStorage.getItem('menus').split(',');
              let i = 0;
              let status = false;
              for (i = 0; i < menu.length; i++) {
                if (menu[i] == 'Absensi Luar Radius') {
                  status = true;
                  break;
                } else {
                  status = false;
                }
              }
              if (status == true) {
                next();
              } else {
                next('/pages/404');
              }
            } else {
              next('/pages/login');
            }
          },
        },
        {
          path: 'absensi-bulan-ramadhan',
          name: 'AbsenBulanRamadhan',
          component: AbsenBulanRamadhan,
          beforeEnter(to, from, next) {
            if (localStorage.getItem('token')) {
              let menu = localStorage.getItem('menus').split(',');
              let i = 0;
              let status = false;
              for (i = 0; i < menu.length; i++) {
                if (menu[i] == 'Absen Bulan Ramadhan') {
                  status = true;
                  break;
                } else {
                  status = false;
                }
              }
              // Force status true for development because the DB might not have the menu yet
              status = true;
              if (status == true) {
                next();
              } else {
                next('/pages/404');
              }
            } else {
              next('/pages/login');
            }
          },
        },
        {
          path: 'koreksi-absensi',
          name: 'KoreksiAbsensi',
          component: KoreksiAbsensi,
          beforeEnter(to, from, next) {
            if (localStorage.getItem('token')) {
              let menu = localStorage.getItem('menus').split(',');
              let i = 0;
              let status = false;
              for (i = 0; i < menu.length; i++) {
                if (menu[i] == 'Koreksi Absensi') {
                  status = true;
                  break;
                } else {
                  status = false;
                }
              }
              if (status == true) {
                next();
              } else {
                next('/pages/404');
              }
            } else {
              next('/pages/login');
            }
          },
        },
        {
          path: 'employee-discipline',
          name: 'EmployeeDiscipline',
          component: KedisiplinanPegawai,
          beforeEnter(to, from, next) {
            if (localStorage.getItem('token')) {
              let menu = localStorage.getItem('menus').split(',');
              let i = 0;
              let status = false;
              for (i = 0; i < menu.length; i++) {
                if (menu[i] == 'Kedisiplinan Pegawai') {
                  status = true;
                  break;
                } else {
                  status = false;
                }
              }
              if (status == true) {
                next();
              } else {
                next('/pages/404');
              }
            } else {
              next('/pages/login');
            }
          },
        },
        {
          path: 'cuti',
          name: 'IzinCutidanLainnya',
          component: IzinCuti,
          beforeEnter(to, from, next) {
            if (localStorage.getItem('token')) {
              let menu = localStorage.getItem('menus').split(',');
              let i = 0;
              let status = false;
              for (i = 0; i < menu.length; i++) {
                if (menu[i] == 'Izin Cuti dan Lainnya') {
                  status = true;
                  break;
                } else {
                  status = false;
                }
              }
              if (status == true) {
                next();
              } else {
                next('/pages/404');
              }
            } else {
              next('/pages/login');
            }
          },
        },
        {
          path: 'uniform',
          name: 'Seragam',
          component: Seragam,
          beforeEnter(to, from, next) {
            if (localStorage.getItem('token')) {
              let menu = localStorage.getItem('menus').split(',');
              let i = 0;
              let status = false;
              for (i = 0; i < menu.length; i++) {
                if (menu[i] == 'Seragam') {
                  status = true;
                  break;
                } else {
                  status = false;
                }
              }
              if (status == true) {
                next();
              } else {
                next('/pages/404');
              }
            } else {
              next('/pages/login');
            }
          },
        },
        {
          path: 'maps',
          name: 'MapsTracking',
          component: MapsTracking,
          beforeEnter(to, from, next) {
            if (localStorage.getItem('token')) {
              let menu = localStorage.getItem('menus').split(',');
              let i = 0;
              let status = false;
              for (i = 0; i < menu.length; i++) {
                if (menu[i] == 'Maps Tracking') {
                  status = true;
                  break;
                } else {
                  status = false;
                }
              }
              if (status == true) {
                next();
              } else {
                next('/pages/404');
              }
            } else {
              next('/pages/login');
            }
          },
        },
        {
          path: 'report',
          name: 'Report',
          component: Report,
          beforeEnter(to, from, next) {
            if (localStorage.getItem('token')) {
              let menu = localStorage.getItem('menus').split(',');
              let i = 0;
              let status = false;
              for (i = 0; i < menu.length; i++) {
                if (menu[i] == 'Team Report') {
                  status = true;
                  break;
                } else {
                  status = false;
                }
              }
              if (status == true) {
                next();
              } else {
                next('/pages/404');
              }
            } else {
              next('/pages/login');
            }
          },
        },
        {
          path: 'reportVDP',
          name: 'ReportVDP',
          component: ReportVDP,
          beforeEnter(to, from, next) {
            if (localStorage.getItem('token')) {
              let menu = localStorage.getItem('menus').split(',');
              let i = 0;
              let status = false;
              for (i = 0; i < menu.length; i++) {
                if (menu[i] == 'Report VDP') {
                  status = true;
                  break;
                } else {
                  status = false;
                }
              }
              if (status == true) {
                next();
              } else {
                next('/pages/404');
              }
            } else {
              next('/pages/login');
            }
          },
        },
        {
          path: 'device',
          name: 'Device',
          component: Device,
          beforeEnter(to, from, next) {
            if (localStorage.getItem('token')) {
              let menu = localStorage.getItem('menus').split(',');
              let i = 0;
              let status = false;
              for (i = 0; i < menu.length; i++) {
                if (menu[i] == 'Reset Device') {
                  status = true;
                  break;
                } else {
                  status = false;
                }
              }
              if (status == true) {
                next();
              } else {
                next('/pages/404');
              }
            } else {
              next('/pages/login');
            }
          },
        },
        {
          path: 'pengumuman',
          name: 'Pengumuman',
          component: Pengumuman,
          beforeEnter(to, from, next) {
            if (localStorage.getItem('token')) {
              let menu = localStorage.getItem('menus').split(',');
              let i = 0;
              let status = false;
              for (i = 0; i < menu.length; i++) {
                if (menu[i] == 'Pengumuman') {
                  status = true;
                  break;
                } else {
                  status = false;
                }
              }
              if (status == true) {
                next();
              } else {
                next('/pages/404');
              }
            } else {
              next('/pages/login');
            }
          },
        },
        {
          path: 'billing',
          name: 'Billing',
          component: Billing,
          beforeEnter(to, from, next) {
            if (localStorage.getItem('token')) {
              // let menu = localStorage.getItem("menus").split(",")
              // let i = 0
              // let status = false
              // for(i=0;i<menu.length;i++) {
              //   if(menu[i] == "Billing") {
              //     status = true
              //     break
              //   } else {
              //     status = false
              //   }
              // }
              // if(status == true) {
              next();
              // } else {
              //   next('/pages/404')
              // }
            } else {
              next('/pages/login');
            }
          },
        },

        // Company
        {
          path: 'company',
          redirect: '/company/list-company',
          name: 'Company',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-company',
              name: 'ListCompany',
              component: DaftarPerusahaan,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Perusahaan') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-company',
              name: 'AddCompany',
              component: TambahPerusahaan,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Setting Daftar Perusahaan') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'approval-company',
              name: 'ApprovalPerusahaan',
              component: ApprovalPerusahaan,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Approval Perusahaan') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'segmen-company',
              name: 'SegmenPerusahaan',
              component: SegmenPerusahaan,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Segmen Perusahaan") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                  // } else {
                  //   next('/pages/404')
                  // }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Employee
        {
          path: 'employee',
          redirect: '/employee/list-employee',
          name: 'Employee',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-employee',
              name: 'ListEmployee',
              component: DaftarPegawai,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Karyawan') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-employee',
              name: 'AddEmployee',
              component: TambahPegawai,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Setting Daftar Karyawan') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Office
        {
          path: 'office',
          redirect: '/office/list-office',
          name: 'Office',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-office',
              name: 'ListOffice',
              component: DaftarKantor,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Kantor') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-office',
              name: 'AddOffice',
              component: TambahKantor,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Setting Daftar Kantor') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Employee Workplace
        {
          path: 'employee-workplace',
          redirect: '/employee-workplace/list-employee-workplace',
          name: 'Employee Workplace',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-employee-workplace',
              name: 'ListEmployeeWorkplace',
              component: DaftarEmployeeWorkplace,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Penempatan') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-employee-workplace',
              name: 'AddEmployeeWorkplace',
              component: TambahEmployeeWorkplace,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Setting Daftar Penempatan') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Stakeholder
        {
          path: 'stakeholder',
          redirect: '/stakeholder/list-stakeholder',
          name: 'Stakeholder',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-stakeholder',
              name: 'ListStakeholder',
              component: DaftarAtasanPegawai,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Atasan') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-stakeholder',
              name: 'AddStakeholder',
              component: TambahAtasanPegawai,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Setting Daftar Atasan') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Unit
        {
          path: 'unit',
          redirect: '/unit/list-unit',
          name: 'Unit',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-unit',
              name: 'ListUnit',
              component: DaftarUnit,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Unit Level') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-unit',
              name: 'AddUnit',
              component: TambahUnit,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Setting Daftar Unit Level') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Jam Kerja
        {
          path: 'jam-kerja',
          redirect: '/jam-kerja/list-jam-kerja',
          name: 'Jam Kerja',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-jam-kerja',
              name: 'ListJamKerja',
              component: DaftarJamKerja,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Jam Kerja') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-jam-kerja',
              name: 'AddJamKerja',
              component: TambahJamKerja,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Setting Daftar Jam Kerja') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Kalendar
        {
          path: 'kalendar',
          redirect: '/kalendar/list-kalendar',
          name: 'Kalendar',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-kalendar',
              name: 'ListKalendar',
              component: DaftarKalendar,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Kalendar') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-kalendar',
              name: 'AddKalendar',
              component: TambahKalendar,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Setting Daftar Kalendar') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Family
        {
          path: 'family',
          redirect: '/family/list-family',
          name: 'Family',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-family',
              name: 'ListFamily',
              component: DaftarKeluarga,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Keluarga') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-family',
              name: 'AddFamily',
              component: TambahKeluarga,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Setting Daftar Keluarga') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Shift
        {
          path: 'shift',
          redirect: '/shift/list-shift',
          name: 'Shift',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-shift',
              name: 'ListShift',
              component: DaftarShift,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Shift') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-shift',
              name: 'AddShift',
              component: TambahShift,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Setting Daftar Shift') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Role
        {
          path: 'role',
          redirect: '/role/list-role',
          name: 'Role',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-role',
              name: 'ListRole',
              component: DaftarRole,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Role') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-role',
              name: 'AddRole',
              component: TambahRole,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Setting Daftar Role') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Menu
        {
          path: 'menu',
          redirect: '/menu/list-menu',
          name: 'Menu',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-menu',
              name: 'ListMenu',
              component: DaftarMenu,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Menu') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-menu',
              name: 'AddMenu',
              component: TambahMenu,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Setting Daftar Menu') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Menu Mobile
        {
          path: 'menu-mobile',
          redirect: '/menu-mobile/add-menu-mobile',
          name: 'MenuMobile',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'add-menu-mobile',
              name: 'AddMenuMobile',
              component: TambahMenuMobile,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Setting Menu Mobile") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                  // } else {
                  //   next('/pages/404')
                  // }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-menu-pegawai-mobile',
              name: 'AddMenuTipePegawaiMobile',
              component: TambahMenuPegawaiMobile,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Setting Menu Pegawai Mobile") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                  // } else {
                  //   next('/pages/404')
                  // }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Role Menu
        {
          path: 'role-menu',
          redirect: '/role-menu/list-role-menu',
          name: 'RoleMenu',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-role-menu',
              name: 'ListRoleMenu',
              component: DaftarRoleMenu,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Role Menu') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-role-menu',
              name: 'AddRoleMenu',
              component: TambahRoleMenu,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Setting Daftar Role Menu') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Tipe Absen
        {
          path: 'kategori',
          redirect: '/kategori/list-kategori',
          name: 'Kategori',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-kategori',
              name: 'ListKategori',
              component: DaftarKategoriTidakMasuk,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Tipe Absen') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-kategori',
              name: 'AddKategori',
              component: TambahKategoriTidakMasuk,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Setting Tipe Absen') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Tipe Pegawai
        {
          path: 'tipe-pegawai',
          redirect: '/tipe-pegawai/list-tipe-pegawai',
          name: 'TipePegawai',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-tipe-pegawai',
              name: 'ListTipePegawai',
              component: DaftarTipePegawai,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Tipe Pegawai') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-tipe-pegawai',
              name: 'AddTipePegawai',
              component: TambahTipePegawai,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Setting Daftar Tipe Pegawai') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Vaksin
        {
          path: 'vaksin',
          redirect: '/vaksin/list-vaksin',
          name: 'Vaksin',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-vaksin',
              name: 'Vaksin',
              component: DaftarVaksin,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Vaksin') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Bauk PO
        {
          path: 'baukPo',
          redirect: '/baukPo/list-baukPo',
          name: 'BaukPo',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-baukPo',
              name: 'BaukPo',
              component: DaftarBaukPo,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Daftar BAUK PO") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                } else {
                  // next('/pages/404')
                  // }
                  // } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Bauk Non PO
        {
          path: 'baukNonPo',
          redirect: '/baukNonPo/list-baukNonPo',
          name: 'BaukNonPo',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-baukNonPo',
              name: 'BaukNonPo',
              component: DaftarBaukNonPo,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Daftar BAUK NON PO") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                } else {
                  // next('/pages/404')
                  // }
                  // } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Kontrak
        {
          path: 'kontrak-perusahaan',
          redirect: '/kontrak-perusahaan/list-kontrak-perusahaan',
          name: 'KontrakPerusahaan',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-kontrak-perusahaan',
              name: 'KontrakPerusahaan',
              component: DaftarKontrakPerusahaan,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Daftar Kontrak Perusahaan") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                } else {
                  // next('/pages/404')
                  // }
                  // } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },
        {
          path: 'kontrak-pegawai',
          redirect: '/kontrak-pegawai/list-kontrak-pegawai',
          name: 'KontrakPegawai',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-kontrak-pegawai',
              name: 'KontrakPegawai',
              component: DaftarKontrakPegawai,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Daftar Kontrak Pegawai") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                } else {
                  // next('/pages/404')
                  // }
                  // } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },
        {
          path: 'pengadaan',
          redirect: '/pengadaan/list-pengadaan',
          name: 'Pengadaan',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-pengadaan',
              name: 'Pengadaan',
              component: DaftarPengadaan,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Daftar Pengadaan") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                } else {
                  // next('/pages/404')
                  // }
                  // } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Magang
        {
          path: 'magang',
          redirect: '/magang/list-magang',
          name: 'Magang',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-magang',
              name: 'ListMagang',
              component: DaftarMagang,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Rekapitulasi Magang') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'add-magang',
              name: 'AddMagang',
              component: TambahMagang,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Setting Magang') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'selesai-magang',
              name: 'SelesaiMagang',
              component: SelesaiMagang,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Selesai Magang') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'report-magang',
              name: 'ReportMagang',
              component: ReportMagang,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Report Magang") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                  // } else {
                  //   next('/pages/404')
                  // }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Reimburse
        {
          path: 'reimburse',
          redirect: '/reimburse/list-reimburse',
          name: 'Reimburse',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'list-reimburse',
              name: 'ListReimburse',
              component: DaftarReimburse,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Reimburse') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'payment-reimburse',
              name: 'PaymentReimburse',
              component: PaymentReimburse,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Payment  Reimburse') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'approval-reimburse',
              name: 'ApprovalReimburse',
              component: ApprovalReimburse,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Approval  Reimburse') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // E Overtime
        {
          path: 'eovertime',
          redirect: '/eovertime/rekapitulasi-eovertime',
          name: 'RekapitulasiEOvertime',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'rekapitulasi-eovertime',
              name: 'RekapitulasiEOvertime',
              component: RekapitulasiEOvertime,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Rekapitulasi E-Overtime') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'detail-eovertime',
              name: 'DetailEOvertime',
              component: DetailEOvertime,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Detail E-Overtime') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Version
        {
          path: 'version',
          redirect: '/version/monitoring-version',
          name: 'MonitoringVersion',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'monitoring-version',
              name: 'MonitoringVersion',
              component: MonitoringVersion,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Monitoring Version') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Gaji
        {
          path: 'payroll',
          redirect: '/payroll/attr-payroll',
          name: 'Gaji',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'attr-payroll',
              name: 'AttrPayroll',
              component: AttrPayroll,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Attribute Gaji") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                  // } else {
                  //   next('/pages/404')
                  // }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'slip-payroll',
              name: 'SlipPayroll',
              component: SlipPayroll,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Slip Gaji") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                  // } else {
                  //   next('/pages/404')
                  // }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'master-payroll',
              name: 'MasterPayroll',
              component: MasterPayroll,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Master Gaji") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                  // } else {
                  //   next('/pages/404')
                  // }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // IBC
        {
          path: 'surat',
          redirect: '/surat/tempat-surat',
          name: 'Tempat',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'tempat-surat',
              name: 'TempatIBC',
              component: TempatIBC,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Tempat Surat') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'jenis-surat',
              name: 'JenisIBC',
              component: JenisIBC,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Jenis Surat') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'action-surat',
              name: 'ActionIBC',
              component: ActionIBC,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Aksi Surat') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'admin-surat',
              name: 'SuratAdmin',
              component: SuratAdmin,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Admin Surat') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'rekap-surat',
              name: 'RekapSurat',
              component: RekapSurat,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Rekap Surat') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'migrasi-surat',
              name: 'MigrasiSurat',
              component: MigrasiSurat,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Migrasi Surat') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'klasifikasi-surat',
              name: 'MasalahIBC',
              component: MasalahIBC,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Kode Klasifikasi') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },

            {
              path: 'disposition-internal',
              name: 'DispositionIBCInternal',
              component: DispositionIBCInternal,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Disposition Internal') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'inbox-internal',
              name: 'InboxIBCInternal',
              component: InboxIBCInternal,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Inbox Internal') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'draft-internal',
              name: 'DraftIBCInternal',
              component: DraftIBCInternal,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Draft Internal') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'sent-internal',
              name: 'SentIBCInternal',
              component: SentIBCInternal,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Sent Internal') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'create-internal',
              name: 'CreateIBCInternal',
              component: CreateIBCInternal,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Create Internal') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'approval-internal',
              name: 'ApprovalIBCInternal',
              component: ApprovalIBCInternal,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Approval Internal') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'request-internal',
              name: 'RequestIBCInternal',
              component: RequestIBCInternal,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Request Internal') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },

            {
              path: 'disposition-eksternal',
              name: 'DispositionIBCEksternal',
              component: DispositionIBCEksternal,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Disposition Eksternal') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'inbox-eksternal',
              name: 'InboxIBCEksternal',
              component: InboxIBCEksternal,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Inbox Eksternal') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'draft-eksternal',
              name: 'DraftIBCEksternal',
              component: DraftIBCEksternal,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Draft Eksternal') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'sent-eksternal',
              name: 'SentIBCEksternal',
              component: SentIBCEksternal,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Sent Eksternal') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'create-eksternal',
              name: 'CreateIBCEksternal',
              component: CreateIBCEksternal,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Create Eksternal') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'approval-eksternal',
              name: 'ApprovalIBCEksternal',
              component: ApprovalIBCEksternal,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Approval Eksternal') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'request-eksternal',
              name: 'RequestIBCEksternal',
              component: RequestIBCEksternal,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Request Eksternal') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'upload-eksternal',
              name: 'UploadIBCEksternal',
              component: UploadIBCEksternal,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Upload Surat') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },

            {
              path: 'lihat-surat/:id/:tipe',
              name: 'LihatIBC',
              component: LihatIBC,
            },
          ],
        },

        // Status
        {
          path: 'status',
          redirect: '/status/approval-status',
          name: 'StatusApproval',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'approval-status',
              name: 'StatusApproval',
              component: StatusApproval,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Status Approval') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Super Administrator
        {
          path: 'admin',
          redirect: '/admin/dashboard',
          name: 'DashboardAdmin',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'dashboard',
              name: 'DashboardAdmin',
              component: DashboardAdmin,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Dashboard Admin") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                  // } else {
                  //   next('/pages/404')
                  // }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'list-admin',
              name: 'Admin',
              component: DaftarAdmin,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  let menu = localStorage.getItem('menus').split(',');
                  let i = 0;
                  let status = false;
                  for (i = 0; i < menu.length; i++) {
                    if (menu[i] == 'Daftar Admin') {
                      status = true;
                      break;
                    } else {
                      status = false;
                    }
                  }
                  if (status == true) {
                    next();
                  } else {
                    next('/pages/404');
                  }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'billing',
              name: 'BillingAdmin',
              component: BillingAdmin,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Billing Admin") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                  // } else {
                  //   next('/pages/404')
                  // }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'approval-billing',
              name: 'ApprovalBilling',
              component: ApprovalBilling,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Approval Billing") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                  // } else {
                  //   next('/pages/404')
                  // }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Testing Covid
        {
          path: 'testing',
          redirect: '/testing/jadwal-tes',
          name: 'JadwalTes',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'jadwal-tes',
              name: 'JadwalTes',
              component: JadwalTes,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Jadwal Tes") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                  // } else {
                  //   next('/pages/404')
                  // }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'daftar-tes',
              name: 'DaftarTes',
              component: DaftarTes,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Daftar Tes") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                  // } else {
                  //   next('/pages/404')
                  // }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'daftar-tes-mandiri',
              name: 'DaftarTesMandiri',
              component: DaftarTesMandiri,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Daftar Tes Mandiri") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                  // } else {
                  //   next('/pages/404')
                  // }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },

        // Testing Covid
        {
          path: 'tracing',
          redirect: '/tracing/hasil-tes',
          name: 'JadwalTes',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          children: [
            {
              path: 'hasil-tes',
              name: 'HasilTes',
              component: HasilTes,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Hasil Tes") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                  // } else {
                  //   next('/pages/404')
                  // }
                } else {
                  next('/pages/login');
                }
              },
            },
            {
              path: 'approval-tes',
              name: 'ApprovalTes',
              component: ApprovalTes,
              beforeEnter(to, from, next) {
                if (localStorage.getItem('token')) {
                  // let menu = localStorage.getItem("menus").split(",")
                  // let i = 0
                  // let status = false
                  // for(i=0;i<menu.length;i++) {
                  //   if(menu[i] == "Hasil Tes") {
                  //     status = true
                  //     break
                  //   } else {
                  //     status = false
                  //   }
                  // }
                  // if(status == true) {
                  next();
                  // } else {
                  //   next('/pages/404')
                  // }
                } else {
                  next('/pages/login');
                }
              },
            },
          ],
        },
      ],
    },
    {
      path: '/bauk/lihat-excel/:id/:month/:year/:tipe',
      name: 'LihatExcel',
      component: LihatExcel,
    },
    {
      path: '/testing/input-tes/:tokens',
      name: 'InputTes',
      component: InputTes,
    },
    {
      path: '/push/notif',
      name: 'PushNotif',
      component: PushNotif,
    },
    {
      path: '/pages',
      redirect: '/pages/login',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view');
        },
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404,
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500,
        },
        {
          path: 'login',
          name: 'Login',
          component: Login,
          beforeEnter(to, from, next) {
            localStorage.setItem('prevUrl', from.fullPath);
            next();
          },
        },
        {
          path: 'register',
          name: 'Register',
          component: Register,
        },
        {
          path: 'privacy-policy',
          name: 'PrivacyPolicy',
          component: PrivacyPolicy,
        },
      ],
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'PageNotFound',
      component: Page404,
    },
  ];
}
